module.exports = __webpack_public_path__ + "img/1586766025.3685abbf.jpg";